import React from 'react';
import styles from './enrichment-header.module.sass';
import { Typography, Tooltip, Table } from 'antd';
import { ColumnTitle } from '../../../../shared-components/ColumnTitle';
import LoadingSkeleton from '../../../../shared-components/LoadingSkeleton';

function EnrichmentHeader({ newData, statusNew, type }) {
  const { Title, Text } = Typography;
  let headers = undefined;

  if (type === 'domain') {
    headers = newData?.response?.scan_data;
  } else if (type === 'ipv4') {
    if (newData?.response?.ip2asn) {
      headers = newData?.response?.ip2asn?.[0]?.scan_data;
    }
  }

  const columns = [
    {
      title: <ColumnTitle columnName="Name" />,
      dataIndex: 'name',
      key: 'name',
      width: 150,
    },
    {
      title: <ColumnTitle columnName="Value" />,
      dataIndex: 'value',
      key: 'value',
      className: 'ant-column-white',
    },
  ];

  function returnTableData({ loading, iocType }) {
    return [
      {
        key: 1,
        name: 'Response',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {headers?.headers?.[0]?.response
              ? headers?.headers?.[0]?.response
              : '-'}
          </Text>
        ),
      },
      {
        key: 2,
        name: 'Server',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {headers?.headers?.[0]?.headers?.server
              ? headers?.headers?.[0]?.headers?.server
              : '-'}
          </Text>
        ),
      },
      {
        key: 3,
        name: 'Expires',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {headers?.headers?.[0]?.headers?.expires
              ? headers?.headers?.[0]?.headers?.expires
              : '-'}
          </Text>
        ),
      },
      {
        key: 4,
        name: 'Content Length',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {headers?.headers?.[0]?.headers?.['content-length']
              ? headers?.headers?.[0]?.headers?.['content-length']
              : '-'}
          </Text>
        ),
      },
      {
        key: 5,
        name: 'Content Type',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {headers?.headers?.[0]?.headers?.['content-type']
              ? headers?.headers?.[0]?.headers?.['content-type']
              : '-'}
          </Text>
        ),
      },
      {
        key: 6,
        name: 'Cache Control',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {headers?.headers?.[0]?.headers?.['cache-control']
              ? headers?.headers?.[0]?.headers?.['cache-control']
              : '-'}
          </Text>
        ),
      },
      {
        key: 7,
        name: 'IP',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {headers?.headers?.[0]?.ip ? headers?.headers?.[0]?.ip : '-'}
          </Text>
        ),
      },
      {
        key: 8,
        name: 'Location',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {headers?.headers?.[0]?.headers?.location
              ? headers?.headers?.[0]?.headers?.location
              : '-'}
          </Text>
        ),
      },
      {
        key: 9,
        name: 'Scan Date',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {headers?.headers?.[0]?.scan_date
              ? headers?.headers?.[0]?.scan_date
              : '-'}
          </Text>
        ),
      },
    ];
  }

  return (
    <div className={styles.enrichment_header}>
      <Title level={4}>Header</Title>
      <Table
        columns={columns}
        dataSource={returnTableData({
          loading: statusNew === 'loading',
          iocType: type,
        })}
        pagination={false}
      />
    </div>
  );
}

export default EnrichmentHeader;
